import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import {
  Earning,
  EarningLedger,
  EarningResponse,
  TreasuryLedger,
  UnifiedTransactionResponse,
} from '../core/state/earnings/earning.model';

@Injectable({ providedIn: 'root' })
export class EarningApiService {
  private http = inject(HttpClient);
  private baseUrl = environment.host;

  getLedger() {
    return this.http.get<EarningLedger>(this.baseUrl + '/api/v1/earnings/ledger');
  }

  getTreasury() {
    return this.http.get<TreasuryLedger>(this.baseUrl + '/api/v1/earnings/admin/treasury');
  }

  getAll(page = 1, limit = 10) {
    return this.http.get<EarningResponse>(
      `${this.baseUrl}/api/v1/earnings?page=${page}&limit=${limit}`
    );
  }

  getAllAdmin(page = 1, limit = 10) {
    return this.http.get<UnifiedTransactionResponse>(
      `${this.baseUrl}/api/v1/earnings/admin/all?page=${page}&limit=${limit}`
    );
  }
}
